<template>
  <JdsPopover
    class="j-site-list__action-button"
    :value="isDropdownOpen"
    :options="popoverOptions"
  >
    <template #activator>
      <div
        v-on-clickaway="closeDropdown"
        @click="toggleDropdown"
      >
        <button class="flex items-center mx-2">
          <JdsIcon
            name="overflow-vertical"
            size="16px"
            class="text-gray-700"
          />
        </button>
      </div>
    </template>
    <div class="bg-white p-2 rounded-lg border border-gray-200 shadow-xl">
      <ul class="flex flex-col items-start">
        <li>
          <BaseButton
            class="text-gray-800 font-normal text-sm border-none"
            data-cy="j-site-list__button-manage"
            @click="$emit('manage')"
          >
            <template #icon-left>
              <SettingIcon class="w-5 h-5 fill-gray-800" />
            </template>
            <p>Kelola Website</p>
          </BaseButton>
        </li>
        <li>
          <BaseButton
            v-if="item.status === 'DRAFT'"
            class="text-red-700 font-normal text-sm border-none"
            data-cy="j-site-list__button-delete"
            @click="$emit('delete')"
          >
            <template #icon-left>
              <JdsIcon
                name="trash"
                size="16px"
                class="w-5 text-red-700"
              />
            </template>
            <p>Hapus</p>
          </BaseButton>
        </li>
      </ul>
    </div>
  </JdsPopover>
</template>

<script>
import BaseButton from '@/common/components/BaseButton';
import SettingIcon from '@/assets/icons/setting.svg?inline';

import { directive as onClickaway } from 'vue-clickaway';

export default {
  name: 'OptionDown',
  components: {
    BaseButton,
    SettingIcon,
  },
  directives: {
    onClickaway,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      popoverOptions: {
        modifiers: [
          {
            name: 'offset',
            options: { offset: [-8, 8] },
          },
        ],
      },
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
  },
};
</script>

<style>
/** Override default jds popover content styling */
.j-site-list__action-button .jds-popover__content {
  z-index: 20 !important;
}
</style>
